import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import candidatesMenuData from "../../data/candidatesMenuData";
import employersData from "@/data/employerMenuData";
import HeaderNavContent from "./HeaderNavContent";
import { isActiveLink } from "../../utils/linkActiveChecker";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { JandiLogo } from "../assets/logos/svgs";
import { logoutUser } from "@/features/user/userSlice";
import { AvatarPlaceholder } from "../candidates/AvatarPlaceholder";
import { removeFcmTokenOnLogout } from "@/utils/pushUtils";

const DashboardHeader = () => {
  const dispatch = useDispatch();
  const { pathname } = useLocation();
  const [navbar, setNavbar] = useState(false);

  const { user } = useSelector((state: { user }) => state.user || {});
  const isWorker = user.type === "worker";
  const data = isWorker ? candidatesMenuData : employersData;

  const changeBackground = () => {
    if (window.scrollY >= 0) {
      setNavbar(true);
    } else {
      setNavbar(false);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", changeBackground);
  }, []);

  return (
    // <!-- Main Header-->
    <header
      className={`main-header header-shaddow  ${navbar ? "fixed-header " : ""}`}
      style={{ backgroundColor: "#ffffff" }}
    >
      <div className="container-fluid">
        {/* <!-- Main box --> */}
        <div className="main-box">
          {/* <!--Nav Outer --> */}
          <div className="nav-outer">
            <div className="logo-box">
              <div className="logo">
                <Link to="/">
                  <JandiLogo />
                </Link>
              </div>
            </div>
            {/* End .logo-box */}

            <HeaderNavContent />
            {/* <!-- Main Menu End--> */}
          </div>
          {/* End .nav-outer */}

          <div className="outer-box">
            {/* <!-- Dashboard Option --> */}
            <div className="dropdown dashboard-option">
              <a
                className="dropdown-toggle"
                role="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                {user.avatar ? (
                  <img
                    alt="avatar"
                    className="thumb"
                    style={{ objectFit: "cover" }}
                    src={user.avatar}
                  />
                ) : (
                  <AvatarPlaceholder className="thumb" />
                )}
                <span className="name">{user.first_name}</span>
              </a>

              <ul className="dropdown-menu">
                {data.map((item) => (
                  <li
                    className={`${
                      isActiveLink(item.routePath, pathname) ? "active" : ""
                    } mb-1`}
                    key={item.id}
                  >
                    <Link
                      to={item.routePath}
                      onClick={
                        item.name === "Logout"
                          ? async () => {
          await removeFcmTokenOnLogout(); // <-- remove token
          dispatch(logoutUser());         // <-- then clear user
        }
                          : () => {}
                      }
                    >
                      <i className={`la ${item.icon}`}></i> {item.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
            {/* End dropdown */}
          </div>
          {/* End outer-box */}
        </div>
      </div>
    </header>
  );
};

export default DashboardHeader;
